<div class="defaultLightbox">
  <h1>{{ lightboxInfo.heading }}</h1>
  <div class='lightboxfooter'>
    <button (click)="onClose.emit()" mat-button >No</button>
    <button mat-button (click)="removeRecipient()" >Yes</button>
  </div>
</div>
